import { readProjectPackageJson } from './read-project-package-json.js'

export function hasPkgScript(cwd: string, script: string): boolean {
  return Boolean(readProjectPackageJson(cwd)?.scripts?.[script])
}
